import { triggerAnimation } from './triggerAnimation';
import { triggerToggleClass } from './triggerToggleClass';
import { triggerAttribute } from './triggerAttribute';
import { triggerEventEmitter } from './triggerEventEmitter';
import { triggerLottie } from './triggerLottie';

export const generateTriggers = (
	settings,
	theTimelines,
	trigger,
	timer,
	index
) => {
	if ( ! settings ) return;
	if ( settings ) {
		if ( settings.animation ) {
			if ( ! trigger.animation ) trigger.animation = [];
			if ( ! timer.animation ) timer.animation = [];
			trigger.animation[ index ] = triggerAnimation(
				settings.animation,
				theTimelines,
				timer.animation,
				index
			);
		}
		if ( settings.toggleClass ) {
			if ( ! trigger.toggle ) trigger.toggle = [];
			if ( ! timer.toggle ) timer.toggle = [];
			trigger.toggle[ index ] = triggerToggleClass(
				settings.toggleClass,
				timer.toggle,
				index
			);
		}
		if ( settings.attribute ) {
			if ( ! trigger.attribute ) trigger.attribute = [];
			if ( ! timer.attribute ) timer.attribute = [];
			trigger.attribute[ index ] = triggerAttribute(
				settings.attribute,
				timer.attribute,
				index
			);
		}
		if ( settings.eventEimitter ) {
			if ( ! trigger.emitter ) trigger.emitter = [];
			if ( ! timer.emitter ) timer.emitter = [];
			trigger.emitter[ index ] = triggerEventEmitter(
				settings.eventEimitter,
				timer.emitter,
				index
			);
		}
		if ( settings.lottie ) {
			if ( ! trigger.lottie ) trigger.lottie = [];
			if ( ! timer.lottie ) timer.lottie = [];
			trigger.lottie[ index ] = triggerLottie(
				settings.lottie,
				timer.lottie,
				index
			);
		}
	}

	const run = () => {
		trigger.animation?.[ index ]?.run();
		trigger.toggle?.[ index ]?.run();
		trigger.attribute?.[ index ]?.run();
		trigger.emitter?.[ index ]?.run();
		trigger.video?.[ index ]?.run();
		trigger.lottie?.[ index ]?.run();
	};

	const kill = () => {
		trigger.animation?.[ index ]?.kill();
		trigger.toggle?.[ index ]?.kill();
		trigger.attribute?.[ index ]?.kill();
		trigger.emitter?.[ index ]?.kill();
		trigger.video?.[ index ]?.kill();
		trigger.lottie?.[ index ]?.kill();
	};

	return { run, kill };
};
